import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M12.9,17.71,11,19.54V6.07H9.73V19.58L7.86,17.71l-.92.92,2.5,2.49a1.32,1.32,0,0,0,.94.39,1.34,1.34,0,0,0,.95-.39l2.49-2.49Z' }),
  React.createElement('path', { d: 'M21,21.19V5.67a2.75,2.75,0,0,0-5.49,0V21.19a4.43,4.43,0,1,0,5.49,0Zm-2.74,6.58a3.12,3.12,0,0,1-1.74-5.71.65.65,0,0,0,.29-.54V5.67a1.45,1.45,0,0,1,2.89,0V21.52a.65.65,0,0,0,.29.54,3.12,3.12,0,0,1-1.73,5.71Z' }),
  React.createElement('path', { d: 'M18.87,22.52V18.19a.65.65,0,0,0-1.3,0v4.33a2.32,2.32,0,1,0,1.3,0Z' }),
  React.createElement('rect', { x: '22.85', y: '4.84', width: '2.21', height: '1.3' }),
  React.createElement('rect', { x: '22.75', y: '8.33', width: '2.21', height: '1.3' }),
  React.createElement('rect', { x: '22.75', y: '11.82', width: '2.21', height: '1.3' }),
  React.createElement('rect', { x: '22.75', y: '15.3', width: '2.21', height: '1.3' }),
  React.createElement('rect', { x: '22.75', y: '18.79', width: '2.21', height: '1.3' })
));